import { CalendarCheck, ShieldCheck, Clock, MessageCircle } from "lucide-react";
import Seo from "../components/Seo";
import { PageHero } from "../components/common/Section";
import ConsultationForm from "../components/forms/ConsultationForm";
import { whatsappLink } from "../components/layout/WhatsAppButton";
import { useSettings } from "../context/SettingsContext";

const POINTS = [
  { icon: CalendarCheck, text: "Free, no-obligation first consultation" },
  { icon: Clock, text: "30–45 minute session, online or by phone" },
  { icon: ShieldCheck, text: "Your details are kept confidential" },
];

export default function BookConsultation() {
  const { settings } = useSettings();
  return (
    <>
      <Seo title="Book a Free Consultation" path="/book-consultation" />
      <PageHero eyebrow="Book Consultation" title="Book Your Free Consultation" text="Tell us a little about yourself and what you'd like to discuss. We'll confirm your slot by phone or email." />
      <section className="bg-slate-100/70 py-20">
        <div className="container-q grid gap-10 lg:grid-cols-[1fr_2fr]">
          <aside className="space-y-6">
            {POINTS.map((p) => <div key={p.text} className="flex items-center gap-3 text-navy"><p.icon className="text-mint" size={20} /><span className="font-medium">{p.text}</span></div>)}
            <a href={whatsappLink(settings?.whatsapp_number, "Hello Quantora, I would like to book a consultation.")} target="_blank" rel="noopener noreferrer" data-testid="book-whatsapp-btn"
              className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-6 py-3 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5"><MessageCircle size={16} /> Book via WhatsApp</a>
            <p className="text-xs leading-relaxed text-slate-500">Consultations provide education and general financial guidance. Regulated advice or product distribution is offered only where the relevant registration or partnership is in place.</p>
          </aside>
          <div className="rounded-[2rem] border border-slate-200 bg-white p-8 shadow-xl sm:p-12">
            <ConsultationForm />
          </div>
        </div>
      </section>
    </>
  );
}
